import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx } from "vue";
import _imports_0 from '@/assets/i.png';
import _imports_1 from '@/assets/payment-methods.png';
const _hoisted_1 = { class: "voucher-cart-page" };
const _hoisted_2 = { class: "cart-content" };
const _hoisted_3 = { class: "purchase-summary-section" };
const _hoisted_4 = { class: "voucher-items" };
const _hoisted_5 = { class: "order-summary" };
const _hoisted_6 = { class: "summary-card" };
const _hoisted_7 = { class: "summary-rows" };
const _hoisted_8 = { class: "summary-row" };
const _hoisted_9 = { class: "summary-value" };
const _hoisted_10 = { class: "summary-row" };
const _hoisted_11 = { class: "summary-value" };
const _hoisted_12 = { class: "summary-row total-row" };
const _hoisted_13 = { class: "summary-value" };
const _hoisted_14 = { class: "cashback-summary" };
const _hoisted_15 = { class: "cashback-earned" };
const _hoisted_16 = { class: "cashback-earned-amount" };
const _hoisted_17 = {
    key: 0,
    class: "saved-to-spend"
};
const _hoisted_18 = { class: "saved-to-spend-info" };
const _hoisted_19 = { class: "saved-text" };
const _hoisted_20 = { class: "saved-balance" };
const _hoisted_21 = {
    key: 0,
    class: "payment-breakdown"
};
const _hoisted_22 = { class: "breakdown-row" };
const _hoisted_23 = { class: "breakdown-value" };
const _hoisted_24 = { class: "breakdown-row" };
const _hoisted_25 = { class: "breakdown-value" };
const _hoisted_26 = { class: "cart-footer" };
import { ref, computed, onMounted, useTemplateRef } from 'vue';
import { useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useVouchers } from '@/composables/useVouchers';
import MGButton from './elements/MGButton.vue';
import MGToggle from './elements/MGToggle.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import DrawerPanel from './elements/DrawerPanel.vue';
import VoucherEditForm from './elements/VoucherEditForm.vue';
import VoucherCartItem from './elements/VoucherCartItem.vue';
import MGDialog from './elements/MGDialog.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'VoucherCartPage',
    setup(__props) {
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomerVouchers, createCart, getCart } = useVouchers();
        const editDrawer = useTemplateRef('editDrawer');
        const isExpressCheckoutAvailable = ref(false);
        const selectedPaymentMethod = ref('card');
        const useSavedToSpend = ref(false);
        const savedToSpendBalance = ref(0);
        const processingFee = ref(0.25);
        const cartItems = ref([]);
        const editingItem = ref(null);
        const showProcessingFeeDialog = ref(false);
        const isKeyboardVisible = ref(false);
        const formatter = {
            format: (value) => `£${value.toFixed(2)}`
        };
        const faceValue = computed(() => {
            if (!cartItems.value || !Array.isArray(cartItems.value))
                return 0;
            return cartItems.value.reduce((total, item) => total + (parseFloat(item.amount) * (item.quantity || 1)), 0);
        });
        const displayProcessingFee = computed(() => {
            return subtotal() > 0 ? processingFee.value : 0;
        });
        const displayTotal = computed(() => {
            if (subtotal() === 0)
                return 0;
            return subtotal() + processingFee.value;
        });
        function onLoad() {
            getCustomerVouchers(() => {
                savedToSpendBalance.value = state.vouchers?.currentSavings || 0;
                loadCartFromSession();
            });
        }
        function subtotal() {
            if (!cartItems.value || !Array.isArray(cartItems.value))
                return 0;
            const voucherTotal = cartItems.value.reduce((total, item) => total + (parseFloat(item.amount) * (item.quantity || 1)), 0);
            if (useSavedToSpend.value && savedToSpendBalance.value > 0) {
                const savedToSpendUsed = Math.min(savedToSpendBalance.value, voucherTotal);
                return Math.max(0, voucherTotal - savedToSpendUsed);
            }
            return voucherTotal;
        }
        function total() {
            return subtotal() + processingFee.value;
        }
        function totalCashback() {
            if (!cartItems.value || !Array.isArray(cartItems.value))
                return 0;
            return cartItems.value.reduce((total, item) => {
                const amount = parseFloat(item.amount);
                const cashbackPercentage = item.availableVoucher?.effectiveDiscountPercentage || 0;
                const cashbackAmount = (amount * cashbackPercentage) / 100;
                return total + (cashbackAmount * (item.quantity || 1));
            }, 0);
        }
        function amountFromOwnMoney() {
            return subtotal() + displayProcessingFee.value;
        }
        function remainingSavedToSpend() {
            if (!useSavedToSpend.value)
                return savedToSpendBalance.value;
            const voucherTotal = cartItems.value.reduce((total, item) => total + (parseFloat(item.amount) * (item.quantity || 1)), 0);
            const savedToSpendUsed = Math.min(savedToSpendBalance.value, voucherTotal);
            return Math.max(0, savedToSpendBalance.value - savedToSpendUsed);
        }
        function removeItem(item) {
            if (!cartItems.value || !Array.isArray(cartItems.value))
                return;
            cartItems.value = cartItems.value.filter(i => i.availableVoucher.id !== item.availableVoucher.id);
            createCart(cartItems.value);
        }
        function proceedToPayment() {
            if (!cartItems.value || !Array.isArray(cartItems.value) || cartItems.value.length === 0) {
                console.error('No items in cart to proceed with payment');
                return;
            }
            console.log('Proceeding to payment...', {
                paymentMethod: selectedPaymentMethod.value,
                subTotal: subtotal(),
                processingFee: processingFee.value,
                total: total(),
                useSavedToSpend: useSavedToSpend.value,
                items: cartItems.value
            });
            var firstVoucherId = cartItems.value[0].availableVoucher.id;
            console.log('Navigating to:', { path: '/vouchers/' + firstVoucherId, query: { total: total(), subTotal: subtotal(), processingFee: processingFee.value, useSavedToSpend: useSavedToSpend.value } });
            router.push({ path: '/vouchers/' + firstVoucherId, query: {
                    pay: 'true',
                    total: total().toString(),
                    subTotal: subtotal().toString(),
                    processingFee: processingFee.value.toString(),
                    useSavedToSpend: useSavedToSpend.value.toString(),
                    amountToPayToday: amountFromOwnMoney().toString(),
                    faceValue: faceValue.value.toString()
                }
            });
        }
        function loadCartFromSession() {
            getCart((r) => {
                cartItems.value = r;
            });
        }
        function openEditDrawer(item) {
            if (item && (item.availableVoucher || item.merchantName)) {
                editingItem.value = item;
                editDrawer.value?.openDrawer();
                setTimeout(() => {
                    isKeyboardVisible.value = true;
                }, 300);
            }
        }
        function closeEditDrawer() {
            editDrawer.value?.closeDrawer();
            isKeyboardVisible.value = false;
        }
        function updateItemAmount(data) {
            if (!cartItems.value || !Array.isArray(cartItems.value)) {
                closeEditDrawer();
                return;
            }
            const found = cartItems.value.find(item => item.availableVoucher.id === editingItem.value.availableVoucher.id);
            if (found) {
                found.amount = data.amount.toString();
                createCart(cartItems.value);
            }
            closeEditDrawer();
        }
        function onDrawerOpened() {
            // Drawer opened
        }
        function onDrawerClosed() {
            isKeyboardVisible.value = false;
            editingItem.value = null;
        }
        function continueShopping() {
            router.push('/ShopVouchers');
        }
        function showProcessingFeeInfo() {
            showProcessingFeeDialog.value = true;
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, { title: "Review your purchase" }),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "section-title" }, "Purchase summary", -1)),
                            _createElementVNode("div", _hoisted_4, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cartItems.value, (item, index) => {
                                    return (_openBlock(), _createBlock(VoucherCartItem, {
                                        key: item.id,
                                        logoUrl: item.availableVoucher.cardUrl,
                                        merchantName: item.availableVoucher?.merchant?.name || item.merchantName || 'Unknown Merchant',
                                        amount: item.amount,
                                        cashbackPercentage: item.availableVoucher?.effectiveDiscountPercentage || item.cashbackPercentage || 0,
                                        formatter: formatter,
                                        showDelete: false,
                                        showBorder: index < cartItems.value.length - 1,
                                        onEdit: ($event) => (openEditDrawer(item)),
                                        onDelete: ($event) => (removeItem(item))
                                    }, null, 8, ["logoUrl", "merchantName", "amount", "cashbackPercentage", "showBorder", "onEdit", "onDelete"]));
                                }), 128))
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "summary-label" }, "Subtotal", -1)),
                                        _createElementVNode("span", _hoisted_9, _toDisplayString(formatter.format(subtotal())), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("span", { class: "summary-label" }, [
                                            _cache[5] || (_cache[5] = _createTextVNode("Payment processing fee ")),
                                            _createElementVNode("img", {
                                                src: _imports_0,
                                                class: "info-icon",
                                                onClick: showProcessingFeeInfo
                                            })
                                        ]),
                                        _createElementVNode("span", _hoisted_11, _toDisplayString(formatter.format(displayProcessingFee.value)), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_12, [
                                        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "summary-label" }, [
                                            _createElementVNode("strong", null, "Total")
                                        ], -1)),
                                        _createElementVNode("span", _hoisted_13, [
                                            _createElementVNode("strong", null, _toDisplayString(formatter.format(displayTotal.value)), 1)
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("div", _hoisted_15, [
                                        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "cashback-earned-label" }, "Cashback you'll earn:", -1)),
                                        _createElementVNode("span", _hoisted_16, _toDisplayString(formatter.format(totalCashback())), 1)
                                    ]),
                                    (savedToSpendBalance.value > 0 && cartItems.value.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                            _createElementVNode("div", _hoisted_18, [
                                                _createElementVNode("div", _hoisted_19, [
                                                    _cache[8] || (_cache[8] = _createElementVNode("span", { class: "saved-title" }, "Use Saved to Spend", -1)),
                                                    _createElementVNode("span", _hoisted_20, _toDisplayString(formatter.format(savedToSpendBalance.value)), 1)
                                                ])
                                            ]),
                                            _createVNode(MGToggle, {
                                                modelValue: useSavedToSpend.value,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((useSavedToSpend).value = $event))
                                            }, null, 8, ["modelValue"])
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createVNode(_Transition, null, {
                                        default: _withCtx(() => [
                                            (useSavedToSpend.value && savedToSpendBalance.value > 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                    _createElementVNode("div", _hoisted_22, [
                                                        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "breakdown-label" }, "Amount you pay today:", -1)),
                                                        _createElementVNode("span", _hoisted_23, _toDisplayString(formatter.format(amountFromOwnMoney())), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_24, [
                                                        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "breakdown-label" }, "Remaining Saved to Spend:", -1)),
                                                        _createElementVNode("span", _hoisted_25, _toDisplayString(formatter.format(remainingSavedToSpend())), 1)
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                    })
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "payment-info" }, [
                            _createElementVNode("span", { class: "powered-by" }, "Powered by Stripe"),
                            _createElementVNode("div", { class: "payment-icons" }, [
                                _createElementVNode("img", {
                                    src: _imports_1,
                                    alt: "Payment methods",
                                    class: "payment-methods-img"
                                })
                            ])
                        ], -1)),
                        (cartItems.value.length > 0)
                            ? (_openBlock(), _createBlock(MGButton, {
                                key: 0,
                                fullWidth: true,
                                text: "Pay by Card",
                                arrow: true,
                                stacked: true,
                                noCaps: true,
                                onClick: proceedToPayment,
                                class: "checkout-button"
                            }))
                            : _createCommentVNode("", true)
                    ]),
                    _createVNode(DrawerPanel, {
                        title: editingItem.value ? (editingItem.value.availableVoucher?.merchant?.name || editingItem.value.merchantName || 'Edit Voucher') : '',
                        icon: editingItem.value ? (editingItem.value.availableVoucher?.cardUrl || editingItem.value.logoUrl || '') : '',
                        ref_key: "editDrawer",
                        ref: editDrawer,
                        startOpened: false,
                        openHeight: "400px",
                        closedHeight: "0px",
                        bottom: "-20px",
                        divider: false,
                        backgroundColor: "white",
                        openBackgroundColor: "white",
                        blurBackground: true,
                        onOpened: onDrawerOpened,
                        onClosed: onDrawerClosed,
                        class: "editDrawer",
                        keyboard: isKeyboardVisible.value
                    }, {
                        default: _withCtx(() => [
                            (editingItem.value)
                                ? (_openBlock(), _createBlock(VoucherEditForm, {
                                    key: 0,
                                    class: "editForm",
                                    availableVoucher: editingItem.value.availableVoucher,
                                    initialAmount: parseFloat(editingItem.value.amount),
                                    onClose: closeEditDrawer,
                                    onUpdate: updateItemAmount,
                                    formatter: formatter
                                }, null, 8, ["availableVoucher", "initialAmount"]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    }, 8, ["title", "icon", "keyboard"])
                ]),
                _createVNode(MGDialog, {
                    modelValue: showProcessingFeeDialog.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((showProcessingFeeDialog).value = $event)),
                    title: "Processing Fee Information",
                    maxWidth: "400px",
                    contentHeight: "auto"
                }, {
                    content: _withCtx(() => _cache[12] || (_cache[12] = [
                        _createElementVNode("div", { class: "processing-fee-info" }, [
                            _createElementVNode("p", null, "A small Stripe transaction processing fee is added to the purchase price. This allows us to provide you with the full cashback amount without any deductions later.")
                        ], -1)
                    ])),
                    actions: _withCtx(() => [
                        _createVNode(MGButton, {
                            text: "Got it",
                            onClick: _cache[1] || (_cache[1] = ($event) => (showProcessingFeeDialog.value = false))
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ], 64));
        };
    }
});
